// extracted by mini-css-extract-plugin
export default {"block":"FilterIfNotBlock_block__1AsZd","text":"FilterIfNotBlock_text__HlYHi"};